'use strict'
module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/node_modules/mdast-util-to-hast/index.js
// module id = c3ZZ
// module chunks = 0